import CasusOverviewPage from "./CasusOverviewPage"

export default CasusOverviewPage
